import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { TableComponent } from '../table/table.component';
import { SharedService } from '../../modules/shared-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import config from 'config/default.json';
import { ApiServiceModule } from '../../modules/api-service.module';
import { HelperModule } from '../../modules/helper.module';
import { MailSenderComponent } from './mail-sender/mail-sender.component';

@Component({
  selector: 'app-student-manager',
  templateUrl: './student-manager.component.html',
  styleUrls: ['./student-manager.component.scss', '../../components/table/table.component.scss']
})
export class StudentManagerComponent extends TableComponent{
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) {
      super(sanitizer);
  }
  @Output() inProgress = new EventEmitter<any>();
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() platformInfos: any = new Map();
  @Input() filterData:any;
  deviceTypes: any[] = [];
  deviceSystems: any[] = [];
  promotionAllData:{[x: string]: any}[] = [];

  ngOnInit() {
    this.loadProducts()
    this.loadData();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterData'] && !changes['filterData'].firstChange) {
      this.loadData();
    }
  }
  loadProducts(){
    this.sharedService.sendData({in_progress: true});
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/promotion/load_all_promotion', {id_user: this.userInfos['id_user'], platform_infos: this.platformInfos}, this.userInfos['access_token']).subscribe((response: any)=>{
      this.promotionAllData = response;
    })
  }
  setWaiting(event:any){

  }
  toggleRow(row:any, clickedElm:any, rowTab:any){
    let toExpand = true;
    for (var tdTab of rowTab.querySelectorAll('.to_skip_element')){
      if(tdTab.contains(clickedElm)){
        toExpand = false;
        break;
      }
    }
    if(toExpand){
      row['expanded'] =! row['expanded'];
    }
  }
  loadData(){
    if(this.filterData && Object.keys(this.filterData).length > 0){
      this.inProgress.emit(true);
      this.filterData.offset = this.navIndex * this.filterData.limit;
      this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/student/load', this.filterData, this.userInfos['access_token']).subscribe((response)=>{
        this.dataSource = response.map((row:any) => {
          row["expanded"] = false;
          row["checked"] = false;
          return row;
        });
        this.showedRows = this.dataSource;
        this.deviceTypes = Array.from(new Set(response.map((el:any)=>el.device_type)));
        this.deviceSystems = Array.from(new Set(response.map((el:any)=>el.device_system)));
        this.totalRows = this.dataSource?.[0]?.total_rows ?? 0;
        this.totalNavigations = Math.ceil(this.totalRows / this.filterData.limit);
        this.inProgress.emit(false);
      });
    }
  }
  setData(response:any){
    
  }
  studentSetting(){
    let selectedRows = this.selectRows();
    if(selectedRows.length){
      const dialogRef = this.dialog.open(MailSenderComponent, {
        width: '80%',
        position: {top: '30px' },
        data: {user_infos: this.userInfos, selected_rows: selectedRows, platform_infos: this.platformInfos}
      });
      dialogRef.afterClosed().subscribe((response:any) => {
      
      });
    }else this.helper.showToast('Select contents first...');
  }
  
  


  sendData(checkedAllRef:any){

    //console.log(this.selectedRows);
  }
  movePrevNextNavigation(action:string) {
    if (action == 'prev' && this.navIndex > 0) {
      this.navIndex--;
      this.loadData();
    }
    if (action == 'next' && this.navIndex < this.totalNavigations - 1) {
      this.navIndex++;
      this.loadData();
    }
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.cdRef.detectChanges();
  }
}
